import { Component } from '@angular/core';

@Component({
  selector: 'da-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  logoSrc =
    'https://res.hc-cdn.com/x-roma-components/1.0.10/assets/devui/logo.svg';
}
